import Signup from "../signup";

const Signin = () => {
  return <Signup />;
};

export default Signin;
